import { useForm } from "@mantine/form";
import { updateHrUserById } from "../../api/hrUserApi";
import {
  Button,
  Loader,
  PasswordInput,
  Select,
  TextInput,
} from "@mantine/core";
import { updateNotification } from "../../utils/useNotification";
import {
  combineValidators,
  validateMaxLength,
  validateMinLength,
  validateRequired,
} from "../../utils/validations";
import { useState } from "react";

const PanelUsersUpdateForm = ({
  user,
  closeModal,
}: {
  user: any;
  closeModal: any;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const form = useForm({
    initialValues: {
      name: user?.name,
      privilege: user?.privilege,
      password: "",
    },
    validate: {
      name: validateRequired,
      password: (value: any) =>
        value
          ? combineValidators(
              validateMaxLength(16),
              validateMinLength(4)
            )(value)
          : null,
      privilege: validateRequired,
    },
  });

  const handleSubmit = async (values: any) => {
    setIsLoading(true);
    try {
      const updates: any = { ...values };
      if (!updates.password) {
        delete updates.password;
      }
      const { data }: any = await updateHrUserById({
        id: user?._id,
        updates,
      });
      updateNotification(data?.success);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
      closeModal();
    }
  };

  return (
    <form
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "15px",
      }}
      onSubmit={form.onSubmit(handleSubmit)}
    >
      <TextInput
        label="Ad Soyad"
        radius={10}
        size="md"
        {...form.getInputProps("name")}
        readOnly={isLoading}
      />
      <Select
        label="Yetki"
        radius={10}
        size="md"
        data={[
          { value: "admin", label: "Admin" },
          { value: "user", label: "User" },
        ]}
        {...form.getInputProps("privilege")}
        readOnly={isLoading}
      />
      <PasswordInput
        label="Şifre (Değiştirmek için yeni şifre girin)"
        radius={10}
        size="md"
        placeholder="Yeni şifre girin"
        {...form.getInputProps("password")}
        readOnly={isLoading}
      />
      <Button
        type="submit"
        color="#5C26FF"
        radius={10}
        disabled={!form.isDirty() || isLoading}
      >
        {isLoading ? <Loader color="#5C26FF" size={24} /> : "Güncelle"}
      </Button>
    </form>
  );
};

export default PanelUsersUpdateForm;
